// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2Is3l","bigColWidth":"Table_bigColWidth__2oP90","biggerColWidth":"Table_biggerColWidth__34qph","row":"Table_row__1-GWy","col":"Table_col__2ng3t"};